import React from 'react'
import { css } from 'aphrodite'
import { Container, Row, Col } from 'reactstrap'

import style from '../style'

export const PerksSection = props => {
  return (
    <Container>
      <header className={css(style.welcome.wrapper)}>
        <h2 className={`d-inline-block ${css(style.welcome.h2)}`}>
          Welcome to{' '}
          <span className={`d-inline-flex ${css(style.welcome.h2Rotator)}`}>
            <span
              className={css(style.welcome.h2InnetTitleWrapper)}
              style={{
                top: `-${props.welcomeText.topOffset}px`
              }}
            >
              {props.welcomeText.list.map((item, index) => (
                <span
                  key={index}
                  className={css(
                    style.welcome.h2InnerTitle,
                    !item.active ? style.welcome.hide : null
                  )}
                >
                  {item.text}
                </span>
              ))}
            </span>
          </span>
        </h2>
        <p className={css(style.welcome.p)}>
          Founded by gamers that run active communities, we understand your
          needs better than any. We have perfected the methods for maximizing
          exposure and generating ad income. Let us share our experience with
          you.
        </p>
      </header>
      <Row>
        <Col xs='12' sm='6' md='4' className={css(style.perks.box)}>
          <h4 className={css(style.perks.h4)}>
            <i className={`fa fa-group ${css(style.perks.icon)}`} />
            Customer Support
          </h4>
          <p className={css(style.perks.p)}>
            This is for you, and we strive to make sure you're happy. You'll
            find that we're here whenever you need us and will guide you through
            the process of automating your income.
          </p>
        </Col>
        <Col xs='12' sm='6' md='4' className={css(style.perks.box)}>
          <h4 className={css(style.perks.h4)}>
            <i className={`fa fa-check ${css(style.perks.icon)}`} />
            Exposure
          </h4>
          <p className={css(style.perks.p)}>
            We'll provide you the best content streams that is available in the
            market, and you can enjoy your community while it pays for itself
            using MOTD Advertising.
          </p>
        </Col>
        <Col xs='12' sm='6' md='4' className={css(style.perks.box)}>
          <h4 className={css(style.perks.h4)}>
            <i className={`fa fa-thumbs-o-up ${css(style.perks.icon)}`} />
            Simple and Easy
          </h4>
          <p className={css(style.perks.p)}>
            Simplifying things for you so you can get what you really want -
            INCOME. We'll help you get you started and generating income as
            quickly as possible.
          </p>
        </Col>
      </Row>
    </Container>
  )
}

export default PerksSection



// WEBPACK FOOTER //
// ./src/components/Home/partials/perks.js